<template>
  <fieldset>
    <SignupLegend :title="`Location of ${formData.name}`"/>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Registered office address</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="address" minlength="2"
               v-model="formData.regAddress.addressLine1" required>
        <div class="invalid-feedback">Registered office address is required.</div>
        <input type="text" class="form-control" placeholder="address" v-model="formData.regAddress.addressLine2">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">City or location</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="city" minlength="2" v-model="formData.regAddress.city"
               required>
        <div class="invalid-feedback">City or location is required.</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Post code</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" placeholder="post code" minlength="6"
               v-model="formData.regAddress.postcode" required>
        <div class="invalid-feedback">Post code is required.</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">Country</label>
      <div class="col-sm-9">
        <BaseSelectCountry v-model="formData.regAddress.country" required/>
        <div class="invalid-feedback">Country is required.</div>
      </div>
    </div>
    <legend>Where should we send the cards to?</legend>
    <div class="form-group row">
      <div class="offset-sm-3 col-sm-9">
        <div class="form-check">
          <input type="checkbox" id="sameAddress" class="form-check-input" @click="toggleAddress"
                 v-model="formData.sameAddress">
          <label class="form-check-label" for="sameAddress">Mail address is same as registered office address</label>
        </div>
      </div>
    </div>
    <div v-if="!formData.sameAddress">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Mail address</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" placeholder="address" minlength="2"
                 v-model="formData.mailAddress.addressLine1" required>
          <div class="invalid-feedback">Mail address is required.</div>
          <input type="text" class="form-control" placeholder="address" v-model="formData.mailAddress.addressLine2">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">City or location</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" placeholder="city" v-model="formData.mailAddress.city" required>
          <div class="invalid-feedback">City or location is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Post code</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" placeholder="post code" minlength="6"
                 v-model="formData.mailAddress.postcode" required>
          <div class="invalid-feedback">Post code is required.</div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Country</label>
        <div class="col-sm-9">
          <BaseSelectCountry v-model="formData.mailAddress.country" required/>
          <div class="invalid-feedback">Country is required.</div>
        </div>
      </div>
    </div>
    <BaseNaviButtons :toSubmit="formData"/>
  </fieldset>
</template>

<script>
  import Address from '@/utils/Address'
  import BaseNaviButtons from '@/components/BaseNaviButtons'
  import BaseSelectCountry from '@/components/BaseSelectCountry'
  import SignupLegend from '@/components/SignupLegend'

  export default {
    components: {
      BaseNaviButtons,
      BaseSelectCountry,
      SignupLegend
    },
    data () {
      return {}
    },
    methods: {
      toggleAddress () {
        this.formData.mailAddress = new Address()
      }
    },
    mounted () {
      if (this.formData.addressSuggestion) this.formData.regAddress = this.formData.addressSuggestion
      delete this.formData.addressSuggestion
    },
    props: {
      formData: Object
    }
  }
</script>

<style scoped>
</style>
